// extracted by mini-css-extract-plugin
module.exports = {"iconBox":"IconBox_iconBox__5UuuJ","widget":"IconBox_widget__1SmZL"};